<template>
  <div class="Certificate">
    <div class="certificate-topbar">
      <h2 v-if="!certificateChecked || certificateFound">
        {{ $t("certificates") }}
      </h2>
      <h2 v-else class="not-found-title">
        {{ $t("certificates__notFound") }} :(
      </h2>
      <p v-if="!certificateChecked || certificateFound">
        {{ $t("certificate__number") }}
      </p>
      <p v-else class="not-found-text">
        {{ $t("certificate__error") }}
      </p>

      <div class="certificate-search-wrapper">
        <div class="certificate-btns-groups">
          <input
            v-model="certificateId"
            type="text"
            placeholder="ID-AT021"
            class="seach-field"
            :class="{ 'error-input': certificateChecked && !certificateFound }"
            @keyup.enter="checkCertificate"
          />
          <button
            @click="checkCertificate"
            class="chack-btn"
            :class="{ 'error-btn': certificateChecked && !certificateFound }"
          >
            {{ $t("certificate__check") }}
            <Icons name="search" />
          </button>

          <!-- HAMMA SERTIFIKATLARNI KONSOLGA CHIQARISH TUGMASI -->
        </div>

        <button
          class="sertificate-download"
          v-if="certificateFound && certificateChecked"
          @click="printCertificate"
        >
          <p>{{ $t("print") }}</p>
          <Icons name="print" />
        </button>
      </div>
    </div>

    <div
      v-if="certificateFound && selectedCertificate"
      class="sertificate-container"
    >
      <SvgSert ref="certificateSvg" :user="selectedCertificate" />
    </div>

    <div v-else-if="certificateChecked" class="not-found">
      <img src="@/assets/Images/folder-cross.png" alt="" />
    </div>
  </div>
</template>

<script>
import Icons from "@/components/Template/Icons.vue";
import SvgSert from "@/components/Template/svgSert.vue";

export default {
  components: { Icons, SvgSert },

  data() {
    return {
      certificateId: "",
      certificateFound: false,
      certificateChecked: false,
      selectedCertificate: null,
      loading: false,
    };
  },

  methods: {
    // HAMMA SERTIFIKATLARNI KONSOLDA KO'RISH

    async checkCertificate() {
      if (!this.certificateId) return;

      this.certificateChecked = false;
      this.certificateFound = false;
      this.selectedCertificate = null;

      try {
        const res = await fetch(
          `https://algowebback-production.up.railway.app/sertificate/sertificate_Id/${this.certificateId}`,
        );

        if (!res.ok) {
          this.certificateFound = false;
          return;
        }

        const data = await res.json();
        console.log(data);

        this.selectedCertificate = data;
        this.certificateFound = true;
      } catch (err) {
        console.error(err);
        this.certificateFound = false;
      } finally {
        this.certificateChecked = true;
      }
    },

    printCertificate() {
      const svg = this.$refs.certificateSvg?.$el?.querySelector("svg");
      if (!svg) return;

      const svgSource = new XMLSerializer().serializeToString(svg);
      const win = window.open("", "PRINT", "width=1200,height=800");

      win.document.write(`
        <html>
          <head>
            <style>
              @page { size: A4 landscape; margin: 0 }
              body { margin:0; display:flex; justify-content:center }
              svg { width:100%; height:auto }
            </style>
          </head>
          <body>${svgSource}</body>
        </html>
      `);

      win.document.close();
      win.focus();
      win.print();
      win.close();
    },
  },
};
</script>

<style>
.Certificate {
  width: 100%;
  height: auto;
  background-color: #000000;
  padding-top: 60px;
}

.certificate-topbar {
  width: 100%;
  height: auto;
  background-color: rgba(13, 13, 13, 1);
  border-radius: 16px;
  padding: 45px;
  margin-bottom: 40px;
}

.certificate-topbar h2 {
  font-size: 60px;
  color: white;
  line-height: 65px;
  padding-right: 15%;
  font-family: Nohemi;
  font-weight: 500;
  max-width: 1000px;
}

.certificate-topbar p {
  font-size: 23px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 100%;
  max-width: 900px;
  font-family: Inter, sans-serif;
  font-weight: 300;
}

.certificate-search-wrapper {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
}

.certificate-search-wrapper .seach-field {
  background-color: #191919;
  width: 242px;
  border-radius: 10px;
  border: 1px solid rgba(248, 218, 10, 1);
  height: 62px;
  color: white;
  font-family: Manrope;
  font-weight: 400;
  font-size: 20px;
  padding-left: 26px;
}

.certificate-btns-groups {
  display: flex;
  align-items: center;
  gap: 21px;
}

.certificate-search-wrapper .chack-btn {
  padding: 17px 29.5px;
  color: black;
  border-radius: 10px;
  font-family: Manrope;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 12px;
  background-color: #f8da0a;
  font-size: 20px;
  cursor: pointer;
}

.sertificate-download {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  font-size: 28px;
  color: #ffffff88;
  font-family: Nohemi;
  font-weight: 500;
  margin-right: 20px;
  background: #191919;
  padding: 12px;
  border-radius: 10px;
  min-width: 280px;
  cursor: pointer;
}
.sertificate-download:hover {
  background: #535353;

  transition: background 0.2s, color 0.2s;
}

.not-found {
  width: 100%;
  height: 886px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(13, 13, 13, 1);
  margin-top: 40px;
  margin-bottom: 40px;

  border-radius: 16px;
}

.not-found-title {
  font-size: 40px;
  color: #f8da0a;
  margin-bottom: 10px;
}

.not-found-text {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.4;
  margin-top: 10px;
}

.error-input {
  border-color: red !important;
  color: red !important;
}

.error-btn {
  background-color: #252525 !important;
}

.certificate-topbar p {
  margin-top: 10px;
}

@media (max-width: 768px) {
  .certificate-topbar h2 {
    font-size: 28px;
    padding-right: 0;
    line-height: 1;
  }

  .certificate-btns-groups {
    flex-direction: column;
    gap: 10px;
  }

  .certificate-search-wrapper .chack-btn {
    width: 100%;
  }

  .certificate-topbar p {
    font-size: 14px;
  }

  .certificate-search-wrapper .seach-field,
  .certificate-search-wrapper .seach-field::placeholder,
  .certificate-search-wrapper .chack-btn {
    font-size: 14px;
    width: 100%;
  }

  .certificate-search-wrapper {
    flex-direction: column;
    gap: 20px;
  }

  .sertificate-download {
    background: #191919;
    width: 100%;
    border-radius: 10px;
    padding: 10px;
    justify-content: center;
  }

  svg > text {
    font-size: 14px;
  }
}
</style>
